// src/features/audit/AuditWorkspacePage.tsx
import { useParams } from 'react-router-dom';

import { PageContainer } from '../../app/components/foundation';
import {
  AuditWorkspaceHeader,
  AuditEventCard,
  AuditActorCard,
  AuditTargetCard,
  AuditMetadataCard,
  AuditTimelineCard,
} from './components';
import { useAuditWorkspaceMock } from './hooks/useAuditWorkspaceMock';
import './styles/audit.css';

/**
 * Audit Workspace Foundation (/audit/:id). Same shell pattern as
 * SecurityWorkspacePage/CommissionWorkspacePage: PageContainer +
 * feature-owned header, card grid below, RTL/Persian throughout,
 * existing tokens/primitives only.
 *
 * Reads `id` from the route params and resolves everything through
 * useAuditWorkspaceMock(id) — the audit record plus its
 * event/actor/target/metadata/timeline, all still mock data from
 * data/audit.mock.ts. No API calls; useAuditWorkspaceMock is the seam
 * a later phase swaps for a real audit-detail hook without touching
 * this file or the cards below it (same shape).
 */
export function AuditWorkspacePage() {
  const { id } = useParams<{ id: string }>();
  const { record, event, actor, target, metadata, timeline } = useAuditWorkspaceMock(id);

  if (!record) {
    return (
      <PageContainer className="flex flex-col gap-6">
        <p className="vania-audit-workspace-empty">رخداد مورد نظر یافت نشد.</p>
      </PageContainer>
    );
  }

  return (
    <PageContainer className="flex flex-col gap-6">
      <AuditWorkspaceHeader record={record} />

      <div className="vania-audit-workspace-grid">
        <AuditEventCard event={event} />
        <AuditActorCard actor={actor} />
        <AuditTargetCard target={target} />
        <AuditMetadataCard metadata={metadata} />
        <AuditTimelineCard timeline={timeline} />
      </div>
    </PageContainer>
  );
}
